import React, { useState, useRef, useEffect } from "react";
import Footer from "../Components/Footer";
import Navbar from "../Components/Navbar";

import HeroUdin from "../Components/Hero";
import NewsGrid from "../Components/editorial/NewsCard";
import OpiniGrid from "../Components/editorial/NewsCardTwo";
import SidebarPopular from "../Components/editorial/sidebarPopular";
import BeritaTerkini from "../Components/editorial/beritaTerkini";
import RekomendasiSlider from "../Components/editorial/RekomendasiSlider";
import FloatingEditorialButton from "../Components/Widget/FloatingEditorialButton";
import TentangKami from "../Components/Tentang/tentang";
import AstaCita from "../Components/Tentang/astacita";
import TujuanProgram from "../Components/Tentang/tujuanprogram";
import axios from "axios";
import FokusKonten from "../Components/Tentang/fokuskonten";

const getDeviceId = () => {
  let deviceId = localStorage.getItem("device_id");

  if (!deviceId) {
    deviceId = crypto.randomUUID();
    localStorage.setItem("device_id", deviceId);
  }

  return deviceId;
};

const HEADER_HEIGHT = 96;
const LandingPageUdin: React.FC = () => {
  const [currentPage, setCurrentPage] = useState("Beranda");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const berandaRef = useRef<HTMLDivElement>(null);
  const fiturRef = useRef<HTMLDivElement>(null);
  const visimisiRef = useRef<HTMLDivElement>(null);
  const tentangKamiRef = useRef<HTMLDivElement>(null);
  const regulasiRef = useRef<HTMLDivElement>(null);
  const jenisGeraiRef = useRef<HTMLDivElement>(null);
  const bantuanRef = useRef<HTMLDivElement>(null);
  const strukturRef = useRef<HTMLDivElement>(null);
  const programRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const recordVisitor = async () => {
      try {
        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/visitor/record`, {
          website_code: "yatim",
          device_id: getDeviceId(),
        });
      } catch (error) {
        console.error("Gagal record visitor", error);
      }
    };

    recordVisitor();
  }, []);

  const handleMenuClick = (page: string) => {
    setTimeout(() => {
      const targetRef = {
        "Home Page": berandaRef,
        About: fiturRef,
        Service: visimisiRef,
        Partnership: jenisGeraiRef,
        Order: tentangKamiRef,
        Output: regulasiRef,
        Bantuan: bantuanRef,
        Struktur: strukturRef,
        Galery: programRef,
      }[page];

      if (targetRef?.current) {
        window.scrollTo({
          top: targetRef.current.offsetTop - HEADER_HEIGHT,
          behavior: "smooth",
        });
      }
    }, 100); // Memberi waktu agar komponen bisa update sebelum scroll

    setIsMenuOpen(false);
  };

  return (
    <section className="font-signika w-full max-w-[1440px] mx-auto  overflow-x-hidden">
      <div className="fixed top-0 left-0 w-full z-40 ">
        <Navbar />
      </div>

      <section className="pt-[70px] max-sm:pt-[70px] grid grid-cols-1">
        <div ref={berandaRef}>
          <HeroUdin />
        </div>

        <div className="max-w-7xl mx-auto px-4 py-10 max-sm:py-5">
          <TentangKami />

          <AstaCita />

          <TujuanProgram />
          <FokusKonten />
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
            <div className="lg:col-span-2">
              <BeritaTerkini />

              <RekomendasiSlider />
              <NewsGrid />

              {/* <OpiniGrid /> */}
            </div>

            <SidebarPopular />
          </div>
        </div>

        <Footer />
      </section>

      <FloatingEditorialButton />
    </section>
  );
};

export default LandingPageUdin;
